module.exports = __webpack_public_path__ + "static/media/centric_logo_white.3e72f4b4.svg";